import { z } from '@botpress/sdk'
import { AgentProject } from '../agent-project/agent-project.js'
import { ADK_VERSION, formatCode } from './utils.js'
import { createFile } from '../utils/fs.js'
import path from 'path'

export async function generateStateTypes(project: AgentProject): Promise<void> {
  let botStateType = '{}'
  let userStateType = '{}'

  // Load the agent config to get state schemas
  try {
    const configPath = path.join(project.path, 'agent.config.ts')
    // Bust module cache to ensure fresh config on type generation
    const configModule = await import(`${configPath}?t=${Date.now()}`)
    const config = configModule.default

    if (config?.bot?.state) {
      const botSchema = config.bot.state as z.ZodTypeAny
      if (botSchema.toTypescriptType) {
        botStateType = botSchema.toTypescriptType()
      }
    }

    if (config?.user?.state) {
      const userSchema = config.user.state as z.ZodTypeAny
      if (userSchema.toTypescriptType) {
        userStateType = userSchema.toTypescriptType()
      }
    }
  } catch (error) {
    console.warn('Failed to load agent config for state types:', error)
  }

  // Generate the type definitions
  const content = `
////////////////////////////////////////////////////////
// DO NOT EDIT THIS FILE DIRECTLY
// This file is auto-generated from the Botpress ADK
// ADK Version: ${ADK_VERSION}
// Generated at: ${new Date().toISOString()}
////////////////////////////////////////////////////////

declare module "@botpress/runtime/_types/state" {
  export type BotState = ${botStateType};
  export type UserState = ${userStateType};
}
`

  // Write to state-types.d.ts in the .adk folder
  const stateTypesPath = path.join(project.path, '.adk', 'state-types.d.ts')
  await createFile(stateTypesPath, await formatCode(content))
}
